import React from 'react'
import { useIntl } from 'react-intl'
import DOC from '../../../../../media/images/DOC.svg'
import JPG from '../../../../../media/images/JPG.svg'
import FLV from '../../../../../media/images/FLV.svg'
import WMA from '../../../../../media/images/WMA.svg'
import ZIP from '../../../../../media/images/ZIP.svg'
import { useThemeMode } from '../../../../../_metronic/partials'
import Skeleton from 'react-loading-skeleton'

const FileUsage = ({ overviewData, loading }: { overviewData?: any; loading?: boolean }) => {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()

  const fileUsageData = [
    {
      id: 'Documents',
      count: `${overviewData?.fileCounts?.documents} files`,
      percentage: `${Math.floor(
        (overviewData?.fileCounts?.documents / overviewData?.recordKeeperFileCount) * 100
      ) || 0
        }%`,
      progress: `${Math.floor(
        (overviewData?.fileCounts?.documents / overviewData?.recordKeeperFileCount) * 100
      )}%`,
      image: DOC,
    },
    {
      id: 'Images',
      count: `${overviewData?.fileCounts?.images} files`,
      percentage: `${Math.floor(
        (overviewData?.fileCounts?.images / overviewData?.recordKeeperFileCount) * 100
      ) || 0
        }%`,
      progress: `${Math.floor(
        (overviewData?.fileCounts?.images / overviewData?.recordKeeperFileCount) * 100
      )}%`,
      image: JPG,
    },
    {
      id: 'Videos',
      count: `${overviewData?.fileCounts?.videos} files`,
      percentage: `${Math.floor(
        (overviewData?.fileCounts?.videos / overviewData?.recordKeeperFileCount) * 100
      ) || 0
        }%`,
      progress: `${Math.floor(
        (overviewData?.fileCounts?.videos / overviewData?.recordKeeperFileCount) * 100
      )}%`,
      image: FLV,
    },
    {
      id: 'Audio',
      count: `${overviewData?.fileCounts?.audio} files`,
      percentage: `${Math.floor((overviewData?.fileCounts?.audio / overviewData?.recordKeeperFileCount) * 100) ||
        0
        }%`,
      progress: `${Math.floor(
        (overviewData?.fileCounts?.audio / overviewData?.recordKeeperFileCount) * 100
      )}%`,
      image: WMA,
    },
    // {id: 'Compressed', count: '50 files', percentage: '10%', progress: '10%', image: ZIP},
    {
      id: 'Others',
      count: `${overviewData?.fileCounts?.others} files`,
      percentage: `${Math.floor(
        (overviewData?.fileCounts?.others / overviewData?.recordKeeperFileCount) * 100
      ) || 0
        }%`,
      progress: `${Math.floor(
        (overviewData?.fileCounts?.others / overviewData?.recordKeeperFileCount) * 100
      )}%`,
      image: ZIP,
    },
  ]

  return (
    <div className='p-6 pb-0 justify-content-between bg-white rounded' style={{ minHeight: '435px' }}>
      <h1 className='font-size-13 mb-6'>{formatMessage({ id: 'Files Usage' })}</h1>
      {fileUsageData.map((file, index) => (
        <div
          className='d-flex justify-content-between align-items-center my-4'
          style={
            mode === 'dark'
              ? { borderBottom: '1px dotted #565674' }
              : { borderBottom: '1px dotted #DBDFE9' }
          }
          key={index}
        >
          {loading ? (
            <div>
              <Skeleton
                width={100}
                height={28}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                className='mb-2'
              />
            </div>
          ) : (
            <div className='w-50 d-flex justify-content-start align-items-center gap-2 mb-1'>
              <img src={file.image} alt={file.id} />
              <div>
                <p className='font-size-13 m-0'>{formatMessage({ id: file.id })}</p>
                <p className='font-size-10 m-0 text-muted'>{formatMessage({ id: file.count })}</p>
              </div>
            </div>
          )}
          {loading ? (
            <div>
              <Skeleton
                width={150}
                height={15}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                className='mb-2'
              />
            </div>
          ) : (
            <div className='w-50 d-flex justify-content-end align-items-center gap-2 mb-1'>
              <div className='h-6px progress' style={{ width: '75%' }}>
                <div
                  className='progress-bar bg-primary'
                  role='progressbar'
                  style={{
                    width: file.progress,
                  }}
                ></div>
              </div>
              <div>
                <p className='font-size-10 text-muted m-0'>
                  {formatMessage({ id: file.percentage })}
                </p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default FileUsage
